module.exports = __webpack_public_path__ + "e078f1f86074945fe06de9a436cdfe72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/sidebar/7.png
// module id = 1130
// module chunks = 73